import React, { ReactElement } from 'react';
import { Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ModalConfirmationMessage, AlyceTheme } from '@alycecom/ui';

const useStyles = makeStyles<AlyceTheme>(({ palette }) => ({
  avatar: {
    backgroundColor: palette.error.main,
  },
  root: {
    borderTop: `4px solid ${palette.error.main}`,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  cancelButton: {
    width: '100%',
  },
  submitButton: {
    width: '100%',
    backgroundColor: palette.error.main,
  },
}));

interface IUnsubscribeAllConfirmationProps {
  isOpen: boolean;
  onSubmit: () => void;
  onDiscard: () => void;
}

const UnsubscribeAllConfirmation = ({ ...modalProps }: IUnsubscribeAllConfirmationProps): ReactElement => {
  const customClasses = useStyles();
  return (
    <ModalConfirmationMessage
      title="Are you sure you want to unsubscribe from Alyce?"
      icon="engine-warning"
      customClasses={customClasses}
      submitButtonText="Unsubscribe"
      cancelButtonText="Cancel"
      backdropStyles={{ top: 0 }}
      width="100%"
      {...modalProps}
    >
      <Typography className="Body-Regular-Left-Static" data-testid="unsubscribeConfirmationText">
        Are you sure? You will decline all your Alyce gift invitations and you will never receive another Alyce email.
      </Typography>
      <Box pt={2} pb={2}>
        <Typography className="Body-Regular-Left-Static" data-testid="unsubscribeConfirmationQuestionText">
          How do you wish to continue?
        </Typography>
      </Box>
    </ModalConfirmationMessage>
  );
};

export default UnsubscribeAllConfirmation;
